// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "root-n80kS";
var _4 = "container-2-T8R";
var _5 = "restrictions-1xhVj";
var _6 = "checkbox__wrapper-2OVim";
var _7 = "checkbox__root-1zCuv";
var _8 = "checkbox__label-2tBN9";
export { _1 as "__esModule", _2 as "tablet", _3 as "root", _4 as "container", _5 as "restrictions", _6 as "checkbox__wrapper", _7 as "checkbox__root", _8 as "checkbox__label" }
export default { "__esModule": _1, "tablet": _2, "root": _3, "container": _4, "restrictions": _5, "checkbox__wrapper": _6, "checkbox__root": _7, "checkbox__label": _8 }
